import { render, staticRenderFns } from "./tabbarItem.vue?vue&type=template&id=1568b2ae&scoped=true&"
import script from "./tabbarItem.vue?vue&type=script&lang=js&"
export * from "./tabbarItem.vue?vue&type=script&lang=js&"
import style0 from "./tabbarItem.vue?vue&type=style&index=0&id=1568b2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568b2ae",
  null
  
)

export default component.exports